import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'password', 'privateKey', 'accessMode' ]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selectedValue = this.accessModeTarget.value;

    if (selectedValue === 'password') {
      this.passwordTarget.style.display = 'block';
      this.privateKeyTarget.style.display = 'none';
    } else if (selectedValue === 'private_key') {
      this.passwordTarget.style.display = 'none';
      this.privateKeyTarget.style.display = 'block';
    } else {
      this.passwordTarget.style.display = 'none';
      this.privateKeyTarget.style.display = 'none';
    }
  }
}
